"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListMore = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Text_1 = require("../../atoms/Text");
var styles_1 = __importDefault(require("./styles"));
/**
 * @deprecated
 */
exports.ListMore = react_1.default.memo(function (_a) {
    var items = _a.items, component = _a.component, size = _a.size, backgroundColor = _a.backgroundColor, _b = _a.maxNumberOfItems, maxNumberOfItems = _b === void 0 ? 2 : _b, _c = _a.justifyContent, justifyContent = _c === void 0 ? 'space-around' : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    var classes = (0, styles_1.default)({ justifyContent: justifyContent });
    var style = { width: size, height: size, backgroundColor: backgroundColor };
    var moreItems = items.length - maxNumberOfItems;
    /* eslint-disable react/no-array-index-key */
    return ((0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ className: "".concat(classes.root, " ").concat(className) }, { children: [items.map(function (item, index) {
                return react_1.default.cloneElement(component, __assign(__assign({}, item), { key: index, style: __assign(__assign({}, style), { display: index >= maxNumberOfItems ? 'none' : '' }) }));
            }), moreItems > 0 && ((0, jsx_runtime_1.jsxs)(Text_1.Text, __assign({ className: classes.textMore, "data-testid": "remaining-items", style: style }, { children: ["+", moreItems] })))] })));
    /* eslint-enable react/no-array-index-key */
});
